import s from './instituicoes/state'
import * as a from './instituicoes/actions'
import * as m from './instituicoes/mutations'
import * as g from './instituicoes/getters'

export const state = s
export const actions = {...a}
export const mutations = {...m}
export const getters = {...g}
